module.exports = __webpack_public_path__ + "img/loginLogo.9a3a9481.png";